import { MiscellaneousField } from '../../reportsTypes';

export function groupFieldsByDependency(
  miscellaneousFields: Record<string, MiscellaneousField>
): string[][] {
  if (!miscellaneousFields) return [];

  // First, sort field names by order (if specified)
  const sortedFieldNames = Object.keys(miscellaneousFields).sort((a, b) => {
    const orderA = miscellaneousFields[a]?.order ?? Infinity;
    const orderB = miscellaneousFields[b]?.order ?? Infinity;
    return orderA - orderB;
  });

  const groups: string[][] = [];
  const processedFields = new Set<string>();

  for (const fieldName of sortedFieldNames) {
    if (processedFields.has(fieldName)) continue;

    const field = miscellaneousFields[fieldName];
    const dependencyFieldName = field?.validation?.compareField;
    const groupName = field?.group;

    // Check if this field belongs to a named group
    if (groupName) {
      // Find all fields with the same group name
      const groupFields = sortedFieldNames.filter(
        (name) =>
          miscellaneousFields[name]?.group === groupName &&
          !processedFields.has(name)
      );
      if (groupFields.length > 0) {
        groups.push(groupFields);
        groupFields.forEach((name) => processedFields.add(name));
      }
    }
    // Check if this field has a dependency (validation compareField)
    else if (dependencyFieldName) {
      const existingGroup = groups.find((group) =>
        group.some((groupFieldName) => groupFieldName === dependencyFieldName)
      );
      if (existingGroup) {
        existingGroup.push(fieldName);
      } else {
        groups.push([fieldName]);
      }
      processedFields.add(fieldName);
    }
    // Single field (no group, no dependency)
    else {
      groups.push([fieldName]);
      processedFields.add(fieldName);
    }
  }

  return groups;
}
